import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 2381C112-2883-4B31-829E-D656430AB707
 * name share-circle
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/share-circle.svg
 * tags
 * - Arrow 
 */
export const ShareCircleIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M14 16V13C10.39 13 7.81 14.43 6 17C6.72 13.33 8.94 9.73 14 9V6L19 11L14 16Z" /></>, 'ShareCircleIcon');
export default ShareCircleIcon